import React, { useEffect, useState } from 'react';
import { getOrganisationById } from '../api/organisationAPI';
import getLogoSrc from '../utils/logoUtils';
import { formatIntDate } from '../utils/dateUtils';

const PurchaseOrderPrintView = ({ order, orderLines = [] }) => {
  const [org, setOrg] = useState(null);

  const formatDate = (d) => {
    if (!d) return '';
    return new Date(d).toLocaleDateString('en-GB');
  };

  useEffect(() => {
    getOrganisationById(1)
      .then(setOrg)
      .catch(() => {});
  }, []);

  if (!order) return null;

  const logoSrc = getLogoSrc(org?.orgLogo);

  const total = orderLines
    .reduce((sum, l) => sum + Number(l.lineTotal || 0), 0)
    .toFixed(2);

  return (
    <div id="printable-purchase-order" className="mx-auto" style={{ width: '820px' }}>
      <div className="mb-4">
        <div className="d-flex justify-content-between">
          <div style={{ fontSize: '12px' }}>
            {logoSrc && <img src={logoSrc} alt="Logo" style={{ maxWidth: '300px', maxHeight: '60px', marginBottom: '20px' }} />}
            {org && (
              <>
                <div className="fw-bold">{org.orgName}</div>
                <div>{org.orgAddress}</div>
                <div>
                  {org.orgCity} {org.orgState} {org.orgZip}
                </div>
                <div>
                  {org.orgTaxIdDescription}: {org.orgTaxId}
                </div>
              </>
            )}
          </div>
          <div className="fw-bold" style={{ fontSize: '24px' }}>
            PURCHASE ORDER
          </div>
        </div>
      </div>
      <table className="table table-borderless mb-4" style={{ fontSize: '12px' }}>
        <tbody>
          <tr>
            <td className="fw-bold" style={{ width: '33%' }}>Supplier:</td>
            <td className="fw-bold" style={{ width: '33%' }}>Delivery Address</td>
            <td style={{ width: '16%' }}>PO Number</td>
            <td style={{ width: '18%' }}>{order.poNumber}</td>
          </tr>
          <tr>
            <td>{order.supplier?.name || ''}</td>
            <td style={{ whiteSpace: 'pre-line' }}>{order.deliveryAddress || ''}</td>
            <td>PO Date</td>
            <td>{formatIntDate(order.orderDate)}</td>
          </tr>
          <tr>
            <td>{order.supplier.address} {order.supplier.address2}</td>
            <td>{`${order.deliveryCity || ''} ${order.deliveryState || ''} ${order.deliveryZip || ''}`}</td>
            <td>PO Reference</td>
            <td>{order.customField1 || 'N/A'}</td>
          </tr>
          <tr>
            <td>{order.supplier.city} {order.supplier.state} {order.supplier.postCode}</td>
            <td>{order.deliveryContact || ''}</td>
            <td>Delivery Date</td>
            <td>{formatIntDate(order.deliveryDate)}</td>
          </tr>
          <tr>
            <td>{order.supplier.phone}</td>
            <td>{order.deliveryPhone || ''}</td>
            <td>Created By</td>
            <td>{order.createdByUser?.name || ''}</td>
          </tr>
          <tr>
            <td></td>
            <td></td>
            <td>Approval Date</td>
            <td>{formatIntDate(order.approvedDate)}</td>
          </tr>
          <tr>
            <td></td>
            <td></td>
            <td>Approved By</td>
            <td>{order.approvedByUser?.name || ''}</td>
          </tr>
        </tbody>
      </table>
      {orderLines.length > 0 && (
        <div className="table-responsive">
          <table className="table bordered-table mb-0 w-100 rounded-0" style={{ fontSize: '12px' }}>
            <thead>
              <tr>
                <th>Item Code</th>
                <th>Work Order</th>
                <th>Description</th>
                <th>Qty</th>
                <th>Unit Price</th>
                <th>Tax %</th>
                <th className="text-end">Tax Total</th>
                <th className="text-end">Total</th>
              </tr>
            </thead>
            <tbody>
              {orderLines.map((ln, idx) => {
                const taxTotal = (
                  Number(ln.quantity) *
                  Number(ln.unitPrice) *
                  (Number(ln.taxRate))
                ).toFixed(2);
                return (
                  <tr key={idx}>
                    <td>{ln.itemCode}</td>
                    <td>{ln.workOrderNumber || ''}</td>
                    <td>{ln.description}</td>
                    <td>{ln.quantity}</td>
                    <td>{ln.unitPrice}</td>
                    <td>{ln.taxRate*100}%</td>
                    <td className="text-end">{taxTotal}</td>
                    <td className="text-end">{ln.lineTotal}</td>
                  </tr>
                );
              })}
              <tr>
                <td colSpan="7" className="text-end fw-bold">
                  Total Amount
                </td>
                <td className="text-end">{total}</td>
              </tr>
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default PurchaseOrderPrintView;
